import { css } from 'aphrodite';
import { UNFILED_FOLDER, IImageLibraryKeyword } from '../../../queries/ImageLibrary';
import { FolderIcon } from '../../components/svgs/icons/FolderIcon';
import { Button } from '../Button';
import { s } from './styles';

interface FolderRailProps {
	folders: IImageLibraryKeyword[];
	/** Null is All. */
	selectedFolder: string | null;
	onSelectFolder: (folder: string | null) => void;
}

/**
 * Folders come from the account-wide keyword list rather than from the loaded page: the library pages 30
 * at a time, so a folder whose images all sit on page four would otherwise be invisible until you scrolled
 * to it.
 */
export function FolderRail({ folders, selectedFolder, onSelectFolder }: FolderRailProps) {
	// Still render while a folder is selected but no longer in the list: unfiling the last entry in a
	// folder, or opening a stale link, would otherwise strip the All control off a filtered, empty grid.
	if (!folders.length && !selectedFolder) {
		return null;
	}

	const renderFolder = (label: string, value: string | null, icon?: React.ReactNode) => (
		<Button
			aria-pressed={selectedFolder === value}
			key={value ?? 'all'}
			onClick={() => onSelectFolder(value)}
			styles={[s.folder, selectedFolder === value && s.folderSelected]}
			variant='ghost'
		>
			{icon}
			{label}
		</Button>
	);

	return (
		<div className={css(s.rail)}>
			{renderFolder('All', null)}
			{renderFolder('Unfiled', UNFILED_FOLDER)}
			{folders.map(folder =>
				renderFolder(`${folder.keyword} (${folder.count})`, folder.keyword, <FolderIcon fillColor='currentColor' />)
			)}
		</div>
	);
}
